var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-previous-exhibitions-boxes__show-more-button-wrapper"},[_c('button',{staticClass:"hiq-previous-exhibitions-boxes__show-more-button",on:{"click":_vm.showMore}},[_vm._v(" Visa fler ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }